<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex md6 xs12>
        <v-card>
          <v-card-title class="subheading">
            {{ textButtonFichar }}
            <v-spacer></v-spacer>
          </v-card-title>

          <v-container grid-list-xs>
            <v-form ref="form" v-model="valid" lazy-validation v-if="!finFichajes">
              <v-layout wrap ma-4 mt-0>
                <v-flex md12 sm12 v-if="conIncidencia">
                  <v-select
                    prepend-icon="location_city"
                    :items="incidencias"
                    v-model="incidenceTypeId"
                    item-text="text"
                    item-value="incidenceTypeId"
                    label="Incidencia"
                    :rules="incidenciaRules"
                    required
                  ></v-select>
                </v-flex>

                <v-flex md12 sm12>
                  <v-text-field
                    prepend-icon="how_to_reg"
                    readonly
                    v-model="usuario"
                    label="Usuario"
                    hint="Nombre del usuario que realiza el fichaje"
                  ></v-text-field>
                </v-flex>
                <v-flex md12 sm12>
                  <v-text-field
                    prepend-icon="access_time"
                    readonly
                    v-model="fechaActual"
                    label="Fecha/Hora"
                    hint="Fecha/Hora que se realizará el fichaje"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <btn-largo
                    :text="textButtonFichar"
                    fontColor="white--text"
                    color="white--text"
                    :bgcolor="bgColor"
                    v-if="!loading"
                    @click.native="submit"
                    :disabled="botonDeshabilitado"
                  ></btn-largo>

                  <btn-largo
                    text="Cancelar fichaje"
                    fontColor="white--text"
                    color="white--text"
                    bgcolor="blue-grey lighten-1"
                    v-if="loading"
                    @click.native="cancelar"
                  ></btn-largo>
                </v-flex>
                <v-progress-linear v-if="loading" :value="timeProgress"></v-progress-linear>
              </v-layout>
            </v-form>
            <v-alert type="success" v-if="finFichajes">
              Se ha registrado correctamente el fichaje con fecha:
              <strong>{{ fechaFichajeReal }}</strong>
              <v-divider class="my-4 success" style="opacity: 0.22"></v-divider>
              <v-row align="center" no-gutters>
                <v-col class="grow"></v-col>
                <v-spacer></v-spacer>
                <v-col class="shrink">
                  <v-btn color="white" elevation="0" outlined @click="goHome">Volver</v-btn>
                </v-col>
              </v-row>
            </v-alert>
            <v-alert type="error" v-if="!isGeoActivated">
              {{ errorMessage }}
              <v-divider class="my-4 success" style="opacity: 0.22"></v-divider>
              <v-row align="center" no-gutters>
                <v-col class="grow"></v-col>
                <v-spacer></v-spacer>
                <v-col class="shrink">
                  <v-btn color="white" elevation="0" outlined @click="getGeolocation">Reintentar</v-btn>
                </v-col>
              </v-row>
            </v-alert>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex md6 xs12 v-if="isSmAndUp">
        <ultimos-fichajes ref="ultFichaje"></ultimos-fichajes>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState } from "vuex";
import btnLargo from "@/components/commons/btnLargo";
import ultimosFichajes from "@/components/fichajes/ultimosFichajes";
import fechaHoraServerServices from "@/services/fechaHoraServerServices.js";
import fichajeServices from "@/services/fichajeServices.js";
import tipoIncidenciaServices from "@/services/tipoIncidenciaServices.js";
import enterpriseGeoServices from "@/services/enterpriseGeoService.js";
import authenticationService from "@/services/authenticationService.js";

const moment = require("moment");
require("moment/locale/es");

export default {
  props: {
    conIncidencia: {
      type: Boolean,
      default: false
    },
    textButtonFichar: {
      type: String,
      default: "Fichar"
    },
    bgColor: {
      type: String,
      default: "teal"
    }
  },
  components: {
    btnLargo,
    ultimosFichajes
  },
  created() {
    this.$store.commit("global/SET_MIGA", [
      { text: "Inicio", href: "/" },
      { text: "Fichar", href: "/fichar" }
    ]);

    this.$getLocation().then(coordinates => {
      // console.log(coordinates);
      this.latitude = coordinates.lat;
      this.longitude = coordinates.lng;
      this.accuracy = coordinates.accuracy;
    });
  },
  async mounted() {
    var that = this;
    that.fechaActual = moment().format(this.getFormatoFechaToView);
    that.getDateTimeServer();

    this.intervaloFechaSrv = setInterval(function() {
      that.getDateTimeServer();
    }, 4000);

    that.intervaloFechaCli = setInterval(function() {
      that.incrementaFechaLocal();
    }, 1000);

    that.intervaloFechaReload = setInterval(function() {
      location.reload();
    }, 60000 * 2); //2 minutos

    if (this.conIncidencia) {
      this.obtenerTiposIncidencias();
    }
    this.deshabilitarFichaje();
    //aquí coger la geolocalización
    await this.loadGeoData();
    
  },
  beforeDestroy() {
    var that = this;
    if (!!that.intervaloFechaSrv) clearInterval(that.intervaloFechaSrv);
    if (!!that.intervaloFechaCli) clearInterval(that.intervaloFechaCli);
    if (!!that.intervaloFechaReload) clearInterval(that.intervaloFechaReload);
  },
  data() {
    return {
      fechaFichajeReal: null,
      latitude: null,
      longitude: null,
      accuracy: null,
      intervaloFechaCli: null,
      intervaloFechaSrv: null,
      intervaloFechaReload: null,
      loading: false,
      fechaActual: "",
      fechaActualUTC: "",
      varTimeOut: null,
      varTimeOutProgress: null,
      timeProgress: 0,
      valid: false,
      //formatDate: "DD/MM/YYYY HH:mm:ss",
      finFichajes: false,
      incidencias: [],
      incidenceTypeId: null,
      incidenciaRules: [v => !!v || "La incidencia es requerida"],
      //geolocation
      isGeoActivated: false,
      errorMessage: '',
      botonDeshabilitado: true,
      geoData: {
        enterpriseId: null,
        geoLatitude: null,
        geoLongitude: null,
        geoAccuaracy: null
      },
      //end geolocation
    };
  },
  computed: {
    ...mapState("global", ["tiempoFichaje"]),
    usuario: function() {
      return this.user.displayName;
    },
    user: function() {
      return this.$store.state.authentication.user;
    },
    isSmAndUp() {
      return this.$vuetify.breakpoint.smAndUp;
    },
    tiempoFichajeMs: function(){
      return this.tiempoFichaje * 1000;
    },
    tiempoFichajeMsPorc025: function(){
      return this.tiempoFichajeMs * 0.025;
    },
    factorIncremento: function(){
      return (this.tiempoFichajeMsPorc025 /  this.tiempoFichajeMs) * 100;
    }
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    getDateTimeServer() {
      fechaHoraServerServices.getFechaHoraActualServer().then(res => {
        this.fechaActualUTC = moment.utc(res);
        this.fechaActual = moment
          .utc(res)
          .local()
          .format(this.getFormatoFechaToView);
      });
    },
    incrementaFechaLocal() {
      this.fechaActualUTC = moment.utc(this.fechaActualUTC).add(1, "seconds");
      this.fechaActual = moment(this.fechaActual, this.getFormatoFechaToView)
        .add(1, "seconds")
        .format(this.getFormatoFechaToView);
    },
    obtenerTiposIncidencias() {
      tipoIncidenciaServices.getTipos().then(res => {
        this.incidencias = res;
      });
    },
    submit: function() {
      var that = this;
      if (this.$refs.form.validate()) {
        this.loading = true;
        var that = this;
        //YYYY-MM-DDTHH:MI:SS.sssZ
        this.timeProgress = 0;

        /*
        this.varTimeOutProgress = setInterval(function() {
          that.timeProgress = that.timeProgress + 2.5;
        }, 250);
        */

        this.varTimeOutProgress = setInterval(function() {
          that.timeProgress = that.timeProgress + that.factorIncremento;
        }, that.tiempoFichajeMsPorc025);
        this.varTimeOut = setTimeout(function() {
          clearTimeout(this.varTimeOutProgress);
          var datFichaje = {
            employeeId: that.user.employeeId,
            customerId: that.user.customerId,
            fecha: moment
              .utc(that.fechaActualUTC)
              .local()
              .format(that.getFormatoFechaToServer),
            incidenceTypeId: that.conIncidencia ? that.incidenceTypeId : null,
            userId: that.user.userId,
            latitude: that.latitude,
            longitude: that.longitude,
            accuracy: that.accuracy
          };
          fichajeServices.fichar(datFichaje).then(res => {
            if (!!res && !!res.markId) {
              that.loading = false;
              that.finFichajes = true;
              that.fechaFichajeReal = moment
                .utc(res.markDateTime)
                .local()
                .format(that.getFormatoFechaToView);
            }
            that.$refs.ultFichaje.obtenerUltimosFichajes();
            console.log(res);
          });
        }, that.tiempoFichajeMs);
      }
    },
    cancelar: function() {
      clearTimeout(this.varTimeOutProgress);
      clearTimeout(this.varTimeOut);
      this.loading = false;
    },
    getNow: function() {
      const today = new Date();
      const date =
        today.getDate() +
        "/0" +
        (today.getMonth() + 1) +
        "/" +
        today.getFullYear();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date + " " + time;
      this.fechaActual = dateTime;
    },
    async loadGeoData() {
      try {
        if(this.user){
          const userInfo = await  authenticationService.getUser(this.user.userId);
          if(userInfo.isLocationMark){
            this.loading = true;
            this.isGeoActivated = false;
            const response = await enterpriseGeoServices.getEnterpriseGeo();
            this.geoData = response;
            this.getGeolocation(response.geoLatitude, response.geoLongitude);
          }else{
            console.log('entra aquí cuando no necesita la ubicacion para fichar')
            this.habilitarFichaje();
            this.isGeoActivated = true; //realmente esto solo se hace para que el usuario, si realmente no necesita la localización para fichar, no aparezca el error
          }
        }
       
        
      } catch (error) {
        console.error("Error al cargar datos de geolocalización", error);
      } finally {
        this.loading = false;
      }
    },
    getGeolocation: function(lat, long){
      const centroLat = lat;
      const centroLon = long; 
      // console.log(centroLat, centroLon)
      try{
        if (navigator.geolocation) {
          // Comprobar si la geolocalización está disponible
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const { latitude, longitude, accuracy } = position.coords;

              let radioDinamico = 0.2; // 🔹 200 metros por defecto
              if (accuracy > 50) {
                radioDinamico = accuracy / 1000; // 🔹 Ajusta el radio en función de la precisión
              }


              if(this.enGeoValla(centroLat, centroLon,radioDinamico, latitude, longitude)){
                this.isGeoActivated = true; // Si obtenemos la ubicación, está activada
                this.habilitarFichaje();
              }else{
                this.errorMessage = "Estás fuera de la geovalla";
                this.deshabilitarFichaje();
              }
            },
            (error) => {
              console.log("Código de error:", error.code);
              this.deshabilitarFichaje();
              if (error.code === error.PERMISSION_DENIED) {
                this.isGeoActivated = false;
                this.errorMessage =
                  "Has denegado la geolocalización. Actívala en la configuración del navegador.";
                
              } else if (error.code === error.POSITION_UNAVAILABLE) {
                this.errorMessage = "La ubicación no está disponible.";
              } else if (error.code === error.TIMEOUT) {
                this.errorMessage = "Tiempo de espera agotado al obtener la ubicación.";
              } else {
                this.errorMessage = "Error desconocido al obtener la ubicación.";
              }
              // alert(this.errorMessage);
              console.log(this.errorMessage)
            },
            {
              enableHighAccuracy: true,  // 🔹 Intentará obtener la mejor precisión posible
              timeout: 10000,             // ⏳ Espera hasta 10 segundos para mejorar la señal
              maximumAge: 0               // 🔄 No usar ubicaciones en caché
            }
          );
        } else {
          this.errorMessage = 'Geolocalización no soportada en este navegador.';
        }
      }catch(e){
        this.errorMessage = JSON.stringify(e);
      }finally{
        // console.log(this.errorMessage)
      }
    },
    enGeoValla: function(lat, lon, radio, userLat, userLon){

      const R = 6371//radio de la tierra en km
      const dLat = (userLat - lat) * (Math.PI / 180);
      const dLon = (userLon - lon) * (Math.PI / 180);

      const a = 
        Math.sin(dLat/2) * Math.sin(dLat/2)+
        Math.cos(lat*(Math.PI/180)) *
        Math.cos(userLat * (Math.PI/180)) * 
        Math.sin(dLon/2) * Math.sin(dLon/2);

      const c = 2*Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
      const distancia = R * c;

      return distancia <= radio;

    },
    habilitarFichaje: function(){
      this.botonDeshabilitado = false;
    },
    deshabilitarFichaje: function(){
      this.botonDeshabilitado = true;
    },
   

  }
};
</script>
